exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".card-26092783{padding-top:20px}.addSection-f66efda3{padding-left:20px;padding-right:20px;padding-bottom:20px}.addSectionForm-50fe566c{margin-top:15px;display:flex;align-items:center}.addSectionForm-50fe566c .input-dd7d4331{flex:1 1 auto;margin-right:10px}.addSectionForm-50fe566c .input-dd7d4331 input{margin-bottom:0}.addSectionForm-50fe566c .button-3b06cb68{flex:0 1 auto}.addSectionIcon-5c2cf826{margin-right:5px;margin-bottom:3px}.addSectionSpinner-34dbdc7f{margin-right:5px}.Guide-e9b39092{border-top:1px solid #E0E0E0}.isDragging-e6f54649{background-color:#eee}\n", ""]);

// Exports
exports.locals = {
	"card": "card-26092783",
	"addSection": "addSection-f66efda3",
	"addSectionForm": "addSectionForm-50fe566c",
	"input": "input-dd7d4331",
	"button": "button-3b06cb68",
	"addSectionIcon": "addSectionIcon-5c2cf826",
	"addSectionSpinner": "addSectionSpinner-34dbdc7f",
	"Guide": "Guide-e9b39092",
	"isDragging": "isDragging-e6f54649"
};